import { useContext, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import useSession from "../hooks/useSession";

const AuthGaurd = ({ role, permissions }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const { user, removeUser, getCustomItem } = useContext(UserContext)
    const [session, setSession, removeSession] = useSession()

    const checkRole = (position) => {
        const type = typeof role
        switch (type) {
            case 'string':
                return position != role
            case 'object':
                return !role.includes(position);    
            default:
                return true
        }
    }

    const extractParams = (permission) => {
        const currentHash = location.hash.replace('#', '')
        const values = permission.hash.split('/')
        for (let i = 0; i < values.length; i++) {
            const currentParts = currentHash.split('/')
            if (currentParts.length != values.length) continue
            if (values[i].includes(':')) {
                sessionStorage.setItem(values[i].replace(':', ''), currentParts[i])
                values[i] = currentParts[i]
            }
        }        
        const newHash = values.join('/')
        return newHash
    }

    const checkPermissions = (permissions) => {
        let enabled = false
        for(let permission of permissions) {
            const type = typeof permission
            switch (type) {
                case 'string':
                    const projectPermissions = checkProjects()
                    enabled = checkPermission(permission, projectPermissions)    
                    if (enabled == undefined) continue
                    break
                case 'object':
                    const current = location.hash.replace('#', '')
                    const hash = extractParams(permission)
                    if (hash == current) {
                        const projectPermissions = checkProjects()
                        enabled = checkPermission(permission.permission, projectPermissions)
                    } else { continue }
                    if (enabled == undefined) continue
                    break
                default:
                    break
            }
        } 
        return !enabled
    }

    const checkPermission = (permission, aditionalPermissions = null) => {
        const userPermissions = [...user.project_permissions, ...user.global_permissions]
        if (aditionalPermissions) userPermissions.push(...aditionalPermissions)
        const filterPermission = userPermissions.filter((item) => item.abbreviation == permission)
        let enabled = undefined;
        if (filterPermission && filterPermission.length) {
            enabled = filterPermission[0].enabled ? true : false
        }
        return enabled
    }

    const checkProjects = () => {
        const idProject = sessionStorage.getItem('project_id')
        const sessionData = getCustomItem('bunny.Projects')
        if (sessionData && sessionData != 'undefined') {
            const temp = JSON.parse(sessionData)
            const filter = temp.filter(item => item.hash_id_widget_completed_form == idProject)
            const project = filter && filter.length > 0 ? filter[0] : null
            if (project) {
                return project.project_permissions
            }
        }
        return null
    }

    useEffect(() => {
        if (!user) {
            const userData = getCustomItem('bunny.User')

            if (!userData) {
                navigate("/")    
                removeSession()
                removeUser()
            }
        }

        if(user && role && checkRole(user.position)) {
            navigate("/")    
            removeSession()
            removeUser()
        }

        if(user && permissions && checkPermissions(permissions)) {
            navigate("/")   
            removeSession()
            removeUser() 
        }
    }, [user, location.pathname])

    return <Outlet />;
};

export default AuthGaurd;